<template>
    <BasePageDetails v-bind:prop_show_review_buttons="true">
        <template v-slot:slot_staff_roster="slot_props_slot_staff_roster">
            <v-row
            v-if="slot_props_slot_staff_roster.staff_roster!=undefined && slot_props_slot_staff_roster.staff_roster.length!=0">
                <v-col xs="12" sm="12" md="6" lg="6" 
                v-for="(staff,staff_index) in slot_props_slot_staff_roster.staff_roster" 
                v-bind:key="staff_index">
                    <h4>
                        <strong>
                            <!-- staff first_name last_name-->
                            {{staff[0].value}} {{staff[1].value}}
                        </strong>
                    </h4>
                    <v-simple-table dense style="background-color:#dff0d8;">
                        <template v-slot:default>
                            <tbody>
                                <tr 
                                v-for="(staff_attribute,staff_attribute_index) in staff" 
                                v-bind:key="staff_attribute_index">
                                    <td class="text-left">{{staff_attribute.label}}</td>
                                    <td class="text-right">{{staff_attribute.value}}</td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </v-col>
            </v-row>
        </template>
    </BasePageDetails>
</template>

<script>
//########################################
//IMPORTS libs
//########################################

import BasePageDetails from '@/views/base_pages/BasePageDetails';

//########################################
//IMPORTS components
//########################################

//########################################
//MAIN
//########################################
export default {
    name: 'ModuleBhcpfPageDetails',

    components:{
        BasePageDetails
    },

    data: function()
    {
        return {
        }
    }
}

//call all with signature func_imp.call(this,param_1,param_2)
//############################################
//HELPERS
//############################################

//############################################
//API_REQUESTS
//############################################

//############################################
//DATA_OPPS
//############################################

//############################################
//ACTIONS
//############################################
</script>
